import * as yup from 'yup';
const dischargedQueueFilterSchema = yup
    .object()
    .shape({
    status: yup.string().trim()
})
    .defined();
export default dischargedQueueFilterSchema;
